import React from 'react';
import { Box, Typography } from '@mui/material';
import { LinkButton } from 'c-components';
import type { Campaign } from 'c-sdk';
import { useCommonTranslation } from 'c-translation';
import CampaignNotices from 'c-main/Components/Campaign/CampaignReports/CampaignNotices';
import { PostAuthRoutes } from 'c-routes';
import RocketLogo from 'c-assets/rocket.png';

const PCADataComingSoon: React.FC<{ campaign: Campaign }> = ({ campaign }) => (
    <Box>
        <CampaignNotices campaign={campaign} />
        <Box textAlign="center" mt={8}>
            <Typography color="textSecondary" variant="h2">
                {useCommonTranslation('Modules.Main.Campaigns.Overview.pcaDataComingSoon')}
            </Typography>
            <Box>
                <img src={RocketLogo} alt="reporting data coming soon" height={250} />
            </Box>
            <Box mt={4}>
                <LinkButton to={PostAuthRoutes.Campaigns.CampaignList}>
                    {useCommonTranslation(
                        'Modules.Main.Campaigns.Overview.pcaDataComingSoonBtnLabel',
                    )}
                </LinkButton>
            </Box>
        </Box>
    </Box>
);

export default PCADataComingSoon;
